import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-badge',
  styleUrl: 'lab-ds-badge.css',
  shadow: true,
})
export class LabDsBadge {
  @Prop() label: string = 'badge';

  @Prop() variant: 'outlined' | 'ghost' | 'dot' = 'outlined';

  @Prop() state: 'success' | 'error' | 'warning' = 'success';

  @Prop() size: 'medium' | 'small' = 'medium';

  states = {
    success: { color: 'var(--lab-ds-semantic-placeholder-color-bg-dark-success)', icon: 'check_circle' },
    error: { color: 'var(--lab-ds-semantic-placeholder-color-bg-dark-error)', icon: 'error' },
    warning: { color: 'var(--lab-ds-semantic-placeholder-color-bg-dark-warning)', icon: 'warning' },
  };

  render() {
    return (
      <div class={`${this.variant} ${this.state} ${this.size} badge`}>
        <span class="label">{this.label}</span>
        {this.variant === 'dot' ? (
          <lab-ds-icon-not-selectable
            class={`holder ${this.state}`}
            size={`${this.size === 'medium' ? 'x-small' : 'xx-small'}`}
            icon="circle"
            color={this.states[this.state].color}
          />
        ) : (
          <lab-ds-icon-not-selectable class="holder" size={`small`} icon={this.states[this.state].icon} color={this.states[this.state].color} />
        )}
      </div>
    );
  }
}
